"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectInputText = exports.shouldIgnoreFocusEvent = exports.findBlurRelatedTarget = exports.scrollIntoView = exports.closest = exports.isElementOverflownX = exports.detectScrollbarWidth = exports.timeoutFocus = exports.generateId = void 0;
var scroll_into_view_if_needed_1 = require("scroll-into-view-if-needed");
var tslib_1 = require("tslib");
var id = Date.now(); // TFSID 872587 don't start from 0 because Chrome assumes same-id is same-field
function generateId() {
    return "tab-shared-widget-" + id++;
}
exports.generateId = generateId;
/** setTimeout around node.focus, with some safety checks */
function timeoutFocus(node) {
    window.setTimeout(function () {
        if (node && window.document.body.contains(node)) {
            node.focus();
        }
    });
}
exports.timeoutFocus = timeoutFocus;
function detectScrollbarWidth() {
    var div = document.createElement('div');
    div.className = 'scrollbarMeasurement';
    tslib_1.__assign(div.style, {
        width: '100px',
        height: '100px',
        overflowY: 'scroll',
        position: 'absolute',
        visibility: 'hidden',
        border: 'none'
    });
    document.body.appendChild(div);
    var scrollbarWidth = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
    return scrollbarWidth;
}
exports.detectScrollbarWidth = detectScrollbarWidth;
function isElementOverflownX(element) {
    return element && element.clientWidth < element.scrollWidth;
}
exports.isElementOverflownX = isElementOverflownX;
function closest(element, selector) {
    if (element.closest) {
        return element.closest(selector);
    }
    var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    if (!matches) {
        return null;
    }
    var node = element;
    while (node) {
        if (matches.call(node, selector)) {
            return node;
        }
        node = node.parentElement;
    }
    return null;
}
exports.closest = closest;
function scrollIntoView(elem, block) {
    if (block === void 0) { block = 'nearest'; }
    if (!elem) {
        return;
    }
    scroll_into_view_if_needed_1.default(elem, { block: block, behavior: 'auto', scrollMode: 'if-needed' });
}
exports.scrollIntoView = scrollIntoView;
function findBlurRelatedTarget(e) {
    return e.relatedTarget;
}
exports.findBlurRelatedTarget = findBlurRelatedTarget;
// nasty hack to work around Safari bug which dispatches multiple focus events with
// as single click on trackpads: https://github.com/facebook/react/issues/10871
// credit to https://gist.github.com/pmacmillan/5e78836821ac22031567382dadd4a72e
function shouldIgnoreFocusEvent(e) {
    // tslint:disable:no-any
    var target = e.target;
    // tslint:disable:no-any
    var relatedTarget = e.relatedTarget;
    // test if we are ignoring the current event because we recevied another one too soon
    if (target.lastFocusEventMs && e.timeStamp < target.lastFocusEventMs + 100) {
        return true;
    }
    target.lastFocusEventMs = e.timeStamp;
    if (relatedTarget) {
        relatedTarget.lastFocusEventMs = e.timeStamp;
    }
    return false;
}
exports.shouldIgnoreFocusEvent = shouldIgnoreFocusEvent;
function selectInputText(input) {
    window.setTimeout(function () {
        // Defect 706678: only certain element types support setSelectionRange, but Safari prefers it
        try {
            if (input.value) {
                input.setSelectionRange(0, input.value.length);
            }
        }
        catch (e) {
            input.select();
        }
    });
}
exports.selectInputText = selectInputText;
//# sourceMappingURL=DomUtil.js.map